/**
 * Registry key values:
 * * "ctg"
 * * "eudra"
 * * "eupas"
 */
import React, { useMemo } from "react"
import { Tooltip } from "antd"
import { v4 as uuid } from "uuid"
import "./useRegistryBadges.scss"

const colors = {
  default: {
    bg: "white",
    border: "#A0A4A8",
  },
  global: {
    bg: "#EFF8FF",
    border: "#78A9FF",
  },
  ctg: {
    bg: "#FFE3EA",
    border: "#FF7495",
  },
  eudra: {
    bg: "#ECF5E1",
    border: "#9ECF6B",
  },
  eupas: {
    bg: "#ECF5E1",
    border: "#9ECF6B",
  },
  ctis: {
    bg: "#F4F8F5",
    border: "#5A9C56",
  },
  jrct: {
    bg: "#FCF1E6",
    border: "#DE7009",
  },
}

const getBackgroundColor = (type) => {
  switch (type) {
    case "eudra":
      return colors.eudra.bg
    case "eudract":
      return colors.eudra.bg
    case "ctg":
      return colors.ctg.bg
    case "eupas":
      return colors.eupas.bg
    case "ctis":
      return colors.ctis.bg
    case "jrct":
      return colors.jrct.bg
    default:
      return "#0D47A1"
  }
}

const getBorderColor = (type) => {
  switch (type) {
    case "eudra":
      return colors.eudra.border
    case "eudract":
      return colors.eudra.border
    case "ctg":
      return colors.ctg.border
    case "eupas":
      return colors.eupas.border
    case "ctis":
      return colors.ctis.border
    case "jrct":
      return colors.jrct.border
    default:
      return "#0D47A1"
  }
}

const useRegistryBadges = () => {
  const getBadges = (keys = []) => {
    if (keys?.length > 0) {
      return keys.map((type, index) => {
        // title
        let title = ""
        if (type === "eudra" || type === "eudract") title = "EUD"
        if (type === "eupas") title = "EMA RWD"
        else title = type.toUpperCase()

        // tooltip text
        let tooltipText = ""
        if (type === "ctg") tooltipText = "ClinicalTrials.Gov"
        else if (type === "eudra" || type === "eudract")
          tooltipText = "European Union Drug Regulating Authorities Clinical Trials"
        else if (type === "eupas") tooltipText = "EMA RWD Catalogue"
        else if (type === "ctis") tooltipText = "Clinical Trial Information System"
        else if (type === "jrct") tooltipText = "Japan Registry of Clinical Trials"

        return (
          <Tooltip
            title={tooltipText}
            key={uuid()}
          >
            <div
              key={index}
              className="registry-badge"
              style={{
                backgroundColor: getBackgroundColor(type),
                border: `1px solid ${getBorderColor(type)}`,
                whiteSpace: "nowrap",
              }}
            >
              {title}
            </div>
          </Tooltip>
        )
      }, [])
    }
    return null
  }

  return { getBadges }
}

export default useRegistryBadges
